import React, { useState } from 'react';
import useInterval from 'use-interval';

import { DELETE_TIME, DELETE_TIME_SUCCESS } from '../constants';
import Close from './Close';

export default function Alert({
  id,
  children,
  type = 'success',
  size = 'banner',
  onClose = () => { },
  dismissable = true,
  className = ''
}) {

  useInterval(() => dismissable && onClose(false), type === 'success' ? DELETE_TIME_SUCCESS : DELETE_TIME);
  useInterval(() => dismissable && onClose(false), type === 'info' ? 5000 : DELETE_TIME);

  const handleOnClose = () => {
    onClose(false);
  };

  let classes = 'flex items-center justify-between h-14 px-4 ' + className;
  if (type === 'success') {
    classes += ' bg-green-500 text-white';
  }
  if (type === 'danger') {
    classes += ' bg-red-400 text-white';
  }
  if (type === 'warning') {
    classes += ' bg-yellow-400 text-black';
  }
  if (type === 'info') {
    classes += ' bg-primary-400 text-white';
  }

  if (size === 'inline') {
    classes += ' px-4 rounded';
  }
  if (size === 'banner') {
    classes += ' px-8';
  }

  return (
    <div className={classes}>
      <div>{children}</div>
      {dismissable && (
        <Close
          className="cursor-pointer"
          onClick={handleOnClose}
          inverted={type === 'warning'}
        />
      )}
    </div>
  );
}
